import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function BookSection() {
  return <section id="book" className="py-24 bg-rhino-charcoal relative" data-id="element-33">
      <div className="container mx-auto px-6" data-id="element-34">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-35">
          {/* Book Mockup */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-36">
            <FadeIn direction="right" data-id="element-37">
              <motion.div whileHover={{
              scale: 1.05
            }} className="relative w-64 md:w-80" data-id="element-38">
                {/* Book Shadow */}
                <div className="absolute -bottom-8 left-4 right-4 h-8 bg-black/50 blur-xl rounded-full" data-id="element-39"></div>

                {/* Book Cover Image */}
                <img src="https://cdn.magicpatterns.com/uploads/kHtZjNdCUrJyQGktwhNndM/1000175399.jpg" alt="The Rhino Mind Book Cover" className="relative w-full rounded-r-md shadow-2xl border border-rhino-grey" data-id="element-40" />
              </motion.div>
            </FadeIn>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-41">
            <FadeIn data-id="element-42">
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-6" data-id="element-43">
                THE BOOK
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-44">
              <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-45">
                Prepare to transform your mindset. The Rhino Mind book is the
                ultimate guide to breaking through barriers, building
                unshakeable discipline, and charging toward your God-given
                potential. It's not just theory; it's a battle-tested strategy
                for life.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-46">
              <button disabled className="px-8 py-4 bg-rhino-grey text-gray-500 font-heading font-bold text-lg tracking-wider uppercase rounded cursor-not-allowed border border-rhino-grey" data-id="element-47">
                Coming Soon
              </button>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="px-8 py-4 bg-rhino-gold text-rhino-black font-heading font-bold text-lg tracking-wider uppercase rounded shadow-[0_0_15px_rgba(212,160,23,0.2)] hover:bg-rhino-gold-hover transition-all" data-id="element-48">
                Get Notified
              </motion.button>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}